// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": () => import("C:\\Users\\test\\Desktop\\gatsby-sophia-school\\src\\templates\\blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-pages-about-js": () => import("C:\\Users\\test\\Desktop\\gatsby-sophia-school\\src\\pages\\about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("C:\\Users\\test\\Desktop\\gatsby-sophia-school\\src\\pages\\index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

